import { render, staticRenderFns } from "./Creation.vue?vue&type=template&id=ab16c496&scoped=true&"
import script from "./Creation.vue?vue&type=script&lang=js&"
export * from "./Creation.vue?vue&type=script&lang=js&"
import style0 from "./Creation.vue?vue&type=style&index=0&id=ab16c496&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab16c496",
  null
  
)

export default component.exports